// laeebly-front/src/theme/foundations/colors.js 와 동일한 토큰.
// 본 앱의 값이 원본이며, 변경 시 양쪽을 함께 수정한다.
const colors = {
  brand: {
    50: '#e6f7f5', 100: '#b3e8e2', 200: '#80d9cf', 300: '#4dcabc', 400: '#26bfad',
    500: '#3cb7a0', 600: '#2ea08b', 700: '#228574', 800: '#176a5c', 900: '#0d4f45',
  },
  neutral: {
    50: '#fafaf8', 100: '#f5f4f0', 200: '#eae8e3', 300: '#d4d1ca', 400: '#a09c94',
    500: '#7a7670', 600: '#5c5856', 700: '#3d3b39', 800: '#262524', 900: '#1a1918', 950: '#111010',
  },
  accent: {
    50: '#fdf6e8', 100: '#f9e8c4', 200: '#f2d08a', 300: '#e4b44e', 400: '#d49a2a',
    500: '#c2841a', 600: '#a06c14', 700: '#7d5310', 800: '#5a3c0b', 900: '#3d2907',
  },
  status: { success: '#2d8a6e', warning: '#c2841a', error: '#c43e3e', info: '#3cb7a0' },
};

export default colors;
